import { takeEvery } from 'redux-saga';
import { call, put, select, take } from 'redux-saga/effects';
import { postJSON, getJSON } from '../util';

export function* purchaseCoins() {
    const user = yield select(state => state.user);
    const upc = yield select(state => state['karmacoin-store'].upc);

    yield put({
        type: 'product:type',
        payload: 'Karma Coins',
    });

    if (!user.logged_in) {
        yield [
            put({
                type: 'route:to',
                payload: 'login',
            }),
            take('user:logged-in'),
        ];
    }

    yield put({
        type: 'product:submitting',
        payload: true,
    });

    try {
        const response = yield call(postJSON, `/api/product/submit/${upc}`);

        yield put({
            type: 'location:href',
            payload: response.forwarding_url,
        });
    } catch (e) {
        yield [
            put({
                type: 'product:error',
                payload: e,
            }),
            put({
                type: 'product:submitting',
                payload: false,
            }),
        ];
    }
}

export function* getKarmaCoinPackages() {
    const packages = yield call(getJSON, '/api/product/karmacoin-packages');

    yield put({
        type: 'karmacoin-store:packages',
        payload: packages,
    });
}

export function* root() {
    const should_run = yield select(state => state['karmacoin-store'] && state['karmacoin-store'].upc);
    if (!should_run) {
        return;
    }

    yield call(getKarmaCoinPackages);

    yield* [
        takeEvery(['user:logged-in', 'user:logged-out'], getKarmaCoinPackages),
        takeEvery('karmacoin-store:purchase', purchaseCoins),
    ];
}



// WEBPACK FOOTER //
// ./app/sagas/karmacoin-store.js